/**
 * @desc 获取星际化客服电话
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** 星际化编码 */
  code: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<string>>(
    `/storeapi/api/v3/store/star/phone`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<string>;
export default req;
